import React, { Component } from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import {showFiltersIfHidden} from "../../actions/actionFunctions";

class FiltersButton extends Component {

  handleFiltersClick = () => {
    this.props.showFiltersIfHidden('selectionWindow');
  };

  render() {
    return (
      <button className={"materials-button " + (this.props.windowWidth >= 991 ? "materials-button--filters " : "materials-button--search")}
              onClick={this.handleFiltersClick}>
        <span className="materials-button__text">
          <FormattedMessage id="quotingTool.main.filtersButton"/>
        </span>
        {this.props.selectedFilters.length ?
          <span className="materials-button--cart-length">{this.props.selectedFilters.length}</span> : null
        }
      </button>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    windowWidth: store.serverState.windowWidth,
    selectedFilters: store.filterState.selectedFilters,
  };
};

export default connect(mapStateToProps, {
  showFiltersIfHidden,
})(FiltersButton);
